<script>
  // The one confirmation dialog. Mounted once, in App.svelte; driven by
  // confirmAction() from lib/confirm.js.
  //
  // Built on the native <dialog> element rather than a positioned div. That is
  // what gives Esc-to-cancel, focus trapping and inertness of the page behind
  // it without writing any of it -- all things window.confirm() also did, and
  // all things a hand-rolled modal usually forgets.
  import { confirmRequest } from "../../lib/confirm.js";

  let dialog;

  // showModal() throws if called on an already-open dialog, and close() on an
  // already-closed one is a no-op, so both are guarded on dialog.open.
  $: if (dialog) {
    if ($confirmRequest && !dialog.open) dialog.showModal();
    if (!$confirmRequest && dialog.open) dialog.close();
  }

  function settle(result) {
    // The store is cleared by settle() itself -- see lib/confirm.js.
    if ($confirmRequest) $confirmRequest.settle(result);
  }

  // Fires for Esc and for close() alike. Only Esc leaves the request unsettled,
  // and cancelling is the right reading of it.
  function onClose() {
    if ($confirmRequest) settle(false);
  }
</script>

<dialog class="modal" bind:this={dialog} on:close={onClose}>
  {#if $confirmRequest}
    <div class="modal-box surface max-w-md p-6 shadow-card">
      <h3 class="text-lg font-semibold">{$confirmRequest.title}</h3>
      {#if $confirmRequest.message}
        <p class="mt-2 text-sm opacity-70 leading-relaxed">
          {$confirmRequest.message}
        </p>
      {/if}
      <div class="mt-6 flex justify-end gap-2">
        <button class="btn btn-sm btn-ghost" on:click={() => settle(false)}>
          {$confirmRequest.cancelLabel}
        </button>
        <button
          class="btn btn-sm {$confirmRequest.tone === 'error'
            ? 'btn-error'
            : 'btn-primary'}"
          on:click={() => settle(true)}
        >
          {$confirmRequest.confirmLabel}
        </button>
      </div>
    </div>
  {/if}
  <!-- daisyUI's backdrop form: clicking outside submits it, which closes the
       dialog and lands in on:close above. -->
  <form method="dialog" class="modal-backdrop">
    <button aria-label="Cancel">close</button>
  </form>
</dialog>

<style>
  .modal-box {
    /* daisyUI's own rounding is larger than the app's card radius. */
    border-radius: var(--rounded-box);
  }
</style>
